
<div class="container">
  <div class="row">
    <div class="col-12">
      <mat-form-field class="example-full-width">
        <mat-label>Email</mat-label>
        <input matInput placeholder="Email" type="email" [(ngModel)]="data.admin.email" >
      </mat-form-field>
      <br>
      <mat-form-field class="example-full-width">
        <mat-label>Lozinka</mat-label>
        <input matInput placeholder="Lozinka" type="text" [(ngModel)]="data.admin.password"  >
      </mat-form-field>
      <br><br>

      <button mat-raised-button color="primary" (click)="save()">Sačuvaj izmene</button>
    </div>
  </div>
</div>
